import React from 'react';
import { Helmet } from 'react-helmet';

const BiteMeBakeryWebsite = () => {
    return (
        <>
            <Helmet>
                <title>BiteMe Bakery AZ Case Study | We Are A Site</title>
                <meta name="description" content="Preview our in-progress design for BiteMe Bakery AZ—a fun, sweet online storefront for local treats." />
            </Helmet>
            <div className='BiteMeBakeryWebsite PortfolioWebsite'>
                <div className='WebsiteHeader'>
                    <img src='/images/BiteMeBakeryIcon.png' alt='Preview' />
                    <div className='WebsiteHeaderInfo'>
                        <span className='BusinessAttribute BusinessName'><span className='BusinessLabel'>Business Name: </span>Bite Me Bakery</span>
                        <span className='BusinessAttribute BusinessType'><span className='BusinessLabel'>Business Type: </span>Bakery</span>
                        <span className='BusinessAttribute BusinessLaunchYear'><span className='BusinessLabel'>Launch Year: </span>2025</span>
                        <span className='BusinessAttribute BusinessLink'><span className='BusinessLabel'>Link: </span><a href='https://bitemebakery.com' target='blank'>https://bitemebakery.com</a></span>
                    </div>
                </div>
                <div className="WebsiteSection WebsiteDescription">
                    <h1>Description:</h1>
                    <span></span>
                </div>
                <div className="WebsiteSection WebsiteSpecialFeatures">
                    <h1>Special Features:</h1>
                    <span></span>
                </div>
                <div className="WebsiteSection WebsiteTotalPages">
                    <h1>Total Pages:</h1>
                    <span></span>
                </div>
                <div className="WebsiteSection WebsiteDemo">
                    <h1>Demo:</h1>
                    <span></span>
                </div>
            </div>
        </>
    );
};

export default BiteMeBakeryWebsite;
